import React, { Component } from "react";
import { getCurrentUser } from "../services/authService";
import Button from "react-bootstrap/Button";
import Table from "./common/table";

class ModelsTable extends Component {
  columns = [
    {
      path: "manufacturer_fullname",
      label: "Brand",
      icon: "tools",
      content: (model) => (
        <Button
          variant="link"
          id="brand_link"
          onClick={() => this.props.onShowManufacturer(model.manufacturer_id)}
        >
          {model.manufacturer_fullname}
        </Button>
      ),
    },
    { path: "media_name", label: "Media", icon: "dna" },
    { path: "scale_range", label: "Scale Range", icon: "balance-scale-right" },
    { path: "kit_mold", label: "Kit Mold", icon: "hard-hat" },
    { path: "kit_no", label: "Kit No.", icon: "hashtag" },
  ];

  deleteColumn = {
    key: "delete",
    icon: "trash-alt",
    content: (model) => (
      <button
        //onClick={() => this.props.onDelete(model)}
        onClick={() => {
          if (window.confirm("Are you sure you wish to delete this item?"))
            this.props.onDelete(model);
        }}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  constructor() {
    super();
    const user = getCurrentUser();
    if (user) this.columns.push(this.deleteColumn);
  }

  render() {
    const { data } = this.props;

    return (
      <Table
        columns={this.columns}
        data={data}
        keyColumn="id"
        tableClass="modelsTable"
      />
    );
  }
}

export default ModelsTable;
